import React, { useState } from 'react';
import './CalcCeAverage.css';
import { CalcCeResult } from './CalcCeData';

type Props = {
  calcResult: CalcCeResult
}

export const CalcCeAverage: React.FC<Props> = ({calcResult}) => {
    console.log('calcResult.averageCe');
    console.log(calcResult.averageCe);
    return (
            
        <div className="CalcCeAverage_content">
            <table className="CalcCeAverage_table">
                <tr>
                    <th>Electrolyzer</th>
                    <th>Average CE</th>
                </tr>
                <tr>
                    <td>
                        <span>
                            {(calcResult.electrolyzer)}
                        </span>
                    </td>
                    <td>
                        <span>
                            {(calcResult.averageCe && !isNaN(calcResult.averageCe)) ? calcResult.averageCe.toFixed(2) : 0.0}%
                        </span>
                    </td>
                </tr>
            </table>
        </div>

    );
};
